/**
 * Pause – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

/** Pause playback control. */
export default function PauseIcon({ height, width }: Props) {
  return (
    <svg
      clipRule={'evenodd'}
      fill={`${Colors['light']}`}
      fillRule={'evenodd'}
      xmlns={'http://www.w3.org/2000/svg'}
      height={`${height || 40 * Screen.widthRatio}`}
      width={`${width || 26 * Screen.widthRatio}`}
      viewBox={'0 0 26 40'}
    >
      <path
        d='M0 2.17984C0 0.975947 1.30126 0 2.90645 0H3.49355C5.09874 0 6.4 0.975946 6.4 2.17984V37.8202C6.4 39.0241 5.09874 40 3.49355 40H2.90645C1.30126 40 0 39.0241 0 37.8202V2.17984Z'
        fill={Colors['light']}
      />
      <path
        d='M19.1992 2.17984C19.1992 0.975947 20.5005 0 22.1057 0H22.6928C24.298 0 25.5992 0.975946 25.5992 2.17984V37.8202C25.5992 39.0241 24.298 40 22.6928 40H22.1057C20.5005 40 19.1992 39.0241 19.1992 37.8202V2.17984Z'
        fill={Colors['light']}
      />
    </svg>
  );
}
